import { useState, useRef, useEffect } from "react";
import DownArrow from "../../utils/assets/down-arrow.svg";
import { isEqual } from "lodash";
const GeneralSelectBar = ({ dataset, name, onValueChange }) => {
  const [listData, setListData] = useState(dataset);
  const [isBarOpen, setIsBarOpen] = useState(false);
  const [searchData, setSearchData] = useState([...listData]);
  const [inputValue, setInputValue] = useState("");
  const [value, setValue] = useState(name)

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setInputValue(value);
    const filteredData = listData.filter(
      (item) => (item.title && item.title.toLowerCase().includes(inputValue)) || 
      (item.name && item.name.toLowerCase().includes(inputValue))
    );
    setSearchData(filteredData);
  };

  function useClickOutside(callback) {
    const ref = useRef();

    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          callback();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [callback]);

    return ref;
  }

  useEffect(() => {
    if (!isEqual(dataset, listData)) {
      setListData(dataset);
      setSearchData(dataset);
    }
  }, [dataset]);
  

  const ref = useClickOutside(() => {
    setIsBarOpen(false);
  });

  const handleSubmit = (item) => {
    setValue(item.title || item.name)
    onValueChange(item);
  };
  return (
    <div ref={ref}>
      <div className="card">
        <div
          className=" p-2 d-flex justify-content-between align-items-center"
          // style={{ maxWidth: "150px" }}
          onClick={() => setIsBarOpen(!isBarOpen)}
        >
          {/* <span className="noOverflow">{value}</span> */}
          <span className="">{value}</span>

          <img src={DownArrow} width={15} alt="arrow" />
        </div>
      </div>
      {isBarOpen && (
        <div className="card position-absolute">
          <div className="selectionContainer">
            <div className="m-1 d-flex justify-content-center align-items-center inputSearchBox">
              <input
                value={inputValue}
                placeholder="Type to search"
                className="form-control"
                onChange={handleSearch}
                type="text"
              />
            </div>
            <div className="d-flex flex-column" style={{ padding: "8px" }}>
              {searchData.length > 0 &&
                searchData.map((item) => {
                  return (
                    <span onClick={() => {handleSubmit(item);setIsBarOpen(false)}} className={`px-2 py-1 hover_effect ${item.title === name || item.name === name ? 'itemSelected' : ''}`}  key={item.id}>
                      {item.title || item?.name}
                    </span>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GeneralSelectBar;
